module.exports = __webpack_public_path__ + "static/media/folder.967fd55d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/folder.svg
// module id = 966
// module chunks = 0